<template>
  <section class="bg-white border-b py-8">
    <div class="container max-w-5xl mx-auto m-8">
      <h1 class="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">Om mig</h1>
      <div class="w-full mb-4">
        <div class="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
      </div>

      <div class="flex flex-wrap items-center">
        <div class="w-5/6 sm:w-1/2 p-6">
          <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">Carina Landin</h3>
          <p class="text-gray-600 mb-3">Orden ”normalt” och ”lagom” kan gärna strykas ur det svenska språket om du frågar mig. I min värld finns det inget som är märkligt, konstigt eller fel. </p>

          <p class="text-gray-600 mb-3">Jag är en social ensamvarg som gillar att bygga saker. Jag tycker om fakta, men är inte en teoretiker.
Vi är alla unika individer och det är min utgångspunkt i allt jag gör. <br> En bra dag på jobbet är när jag kan hjälpa någon att se något de redan vet men från ett annat perspektiv.</p>

            <p class="bg-gray-300 p-2 text-gray-600 border-b border-gray-500">Pågående utbildning</p>
            <p class="bg-gray-300 p-2 text-gray-600 font-bold"> Grof® Breathwork and Psychedelic Therapy Training <br>
              <span class="bg-gray-300 text-gray-600 font-normal"> <br>
                Holotropic Breathwork <br>
              </span>
            </p>
          <p class="bg-gray-300 p-2 text-gray-600"> Treårig transpersonell psykoterapiutbildning som grundar sig i Dr. Stanislav Grofs lära. <br> </p>

        </div>

        <div class="w-full sm:w-1/2 p-6 h-1/4">
          <img src="../assets/carinalandin.png" class="rounded-full"/>
        </div>
      </div>

       <div class="flex flex-wrap flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-1/2 p-6 mt-6">
          <img src="@/assets/undraw_friends_r511.svg" />
        </div>
        <div class="w-full sm:w-1/2 p-6 mt-6">
          <div class="align-middle">
            <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">Samtal</h3>
            <p class="text-gray-600 mb-2">
              Trygghet ges i att få växa och bearbeta hämmande mönster, livshändelser samt trauman. En känsla av att du är sedd och hållen till en verklig förändring i ditt liv.<br>

              <p class="text-gray-600 mb-2">Du ökar din medvetenhet och får stöd i att lyssna till det som diffust pågår i vardagen eller orsakar negativa sinnestillstånd.</p>
              <p class="text-gray-600 mb-2">Vi använder samtal, andning, tapping, havening samt holoptropiskt tillstånd vid behov.</p>
              <p class="text-gray-600 mb-2">En ökad förmåga att relatera till dig själv och andra genom ett expanderat livsrum som förstärker känslan av att stå i din sanning.</p>
              <p class="text-gray-600 mb-2">Jag har erfarenhet av stödjande/integrerande samtal efter transpersonella tillstånd/psykedeliska upplevelser</p>

              <p class="text-gray-600 mb-3 italic font-semibold">"Jag har än idag inte använt mig av en mall i enskilda terapier då det inte finns en kopia av dig"
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center">
        <div class="w-5/6 sm:w-1/2 p-6">
          <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">Fysiskt möte eller videosession</h3>
          <p class="text-gray-600 mb-8">Jag erbjuder samtalsterapi i Stockholm och har mottagning med lugnt och centralt läge på Fridhemsplan. <br /> <br />Jag arbetar även med videosessioner med personer runt om i hela landet. <br> Det är helt upp till dig vilken mötesform du känner dig mest bekväm med. <br>  <br>
          Hur många sessioner som behövs är helt individuellt och olika för alla. För vissa räcker 2-3 sessioner, andra vill gå regelbundet under en längre tid för kontinuerlig självutveckling.
           <span class="italic font-semibold mt-4 block">Pris: 1250kr/60min</span><span>Avbokning skall ske 48 timmar innan</span><!--Vid bokning av samtal så väljer du antingen fysiskt eller videomöte --> </p> <br>
        </div>
        <div class="w-full sm:w-1/2 p-6">
          <img src="@/assets/undraw_video_call_kxyp.svg" />
        </div>
      </div>

      <h3 class="w-full my-2 text-2xl font-bold leading-tight text-center text-gray-800">Utbildningar</h3>

      <div class="sm:flex sm:justify-around text-gray-600 text-left p-6">
        <div>
          <ul style="list-style-type:circle;">
            <li><span class="font-semibold">Mindfulness-baserad kognitiv samtalsterapeut</span></li>
            <li><span class="font-semibold">KBT coach och schematerapi</span></li>
          </ul>
        </div>
        <div>
          <ul style="list-style-type:circle;">
            <li><span class="font-semibold">Leg. Arbetsterapeut</span></li>
            <li><span class="font-semibold">Acceptance and commitment therapy</span></li>
          </ul> </div>
        <div>
          <ul style="list-style-type:circle;">
            <li><span class="font-semibold">Diplomerad mindfulnessinstruktör</span></li>
            <li><span class="font-semibold">Havening (under certifiering)</span></li></ul></div>
      </div>

      <div class="text-center mt-5">
        <h3 class="text-3xl text-gray-800 font-bold leading-none mb-3">Klimakteriepodden</h3>
        <p class="text-gray-600">Jag fick äran att vara med i ett avsnitt av <a href="https://www.klimakteriepodden.se/" class="italic underline">klimakteriepodden</a> där vi diskuterade hur vi kan hantera oro och ångest. <br><br>Klicka nedan för att lyssna.</p>
        <div class="flex mx-auto w-full sm:w-1/2 p-6 rounded-full">
          <a class="w-full" href="https://aca.st/45c475"><img src="@/assets/klimakteriepodden.jpg" /> </a>
        </div>
      </div>
    </div>
</section>
</template>

<script>
export default {

}
</script>

<style>
</style>
